import React, { useEffect, useState } from 'react';
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import { mCPF } from '../utils/masks'
import FooterDelphus from '../components/FooterDelphus'
import { exit } from 'react-icons-kit/icomoon/exit'
import RegClientes from './RegClientes'
import Dialog from '@material-ui/core/Dialog';
import AutoComp from '../components/AutoComp'
import {fileExcel} from 'react-icons-kit/icomoon/fileExcel'
import ReactExport from "react-data-export";

import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, isEmpty } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function Clientes(props) {
  const [data, setData] = useState([])
  const [exportData, setExportData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [comboCid, setComboCid] = useState([{ value: '', display: '' }])
  const [dependentes, setDependentes] = useState(false)
  const [modalRegistro, setModalRegistro] = useState(false)
  const [pk_cli, setPk_Cli] = useState('0')
  const [nomeCli, setNomeCli] = useState('')
  const [comboOri, setComboOri] = useState([{ value: '', display: '' }])
  const [comboSub, setComboSub] = useState([{ value: '', display: '' }])
  const [representante, setRepresentante] = useState()
  const [comboRep, setComboRep] = useState([{ value: '', display: '' }])
  const [comboAtivo, setComboAtivo] = useState([{ value: 'S', display: 'Ativo' }, { value: 'N', display: 'Inativo' },])
  const columns = [
    { id: 'pk_cli', numeric: false, label: 'Código', align: 'left', minWidth: 50 },
    { id: 'cpf', numeric: false, label: 'CPF', align: 'left', minWidth: 100, cpf: true },
    { id: 'nome', numeric: false, label: 'Nome', align: 'left', minWidth: 150 },
    { id: 'cpf_responsavel', numeric: false, label: 'CPF Responsável', align: 'left', minWidth: 100, cpf: true },
    { id: 'nome_responsavel', numeric: false, label: 'Nome Responsável', align: 'left', minWidth: 200 },
    { id: 'nomecid', numeric: false, label: 'Cidade', align: 'left', minWidth: 200 },
    { id: 'ctoVigente', numeric: false, label: 'Cto.Ativo', align: 'left', minWidth: 50 },

  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        customClass: {
          container: 'my-swal'
        },

        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      setComboCid(await api.getComboData('cidades'))
      setComboOri(await api.getComboData('origens_contatos'))
      setComboSub(await api.getComboData('sub_origem'))
      setComboRep(await api.getComboData('representantes'))

      let Tela = 'Clientes'
      setenableAdd(await api.getAcessos(Tela, 'Inclusao'))
      setenableEdit(await api.getAcessos(Tela, 'Alteracao'))
      setenableDel(await api.getAcessos(Tela, 'Exclusao'))

      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      setDependentes(window.location.href.indexOf('dependentes') !== -1)
      if (query.fk_rep)
        setRepresentante(query.fk_rep)

      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    // console.log((queryObject.fk_cid > 0 || queryObject.fk_ori > 0 || queryObject.fk_sub > 0 || queryObject.ativo > 0))
    if (!isEmpty(queryObject) ) {
      queryObject.buscar = true
      if (dependentes)
        queryObject.dependentes = true
      setFiltered(true)
      if (!props.modal) {
        window.history.replaceState({ filtered: true }, 'filter', "/salute/clientes?" + objectToQueryString(queryObject));
      }
      swal.fire({
        customClass: {
          container: 'my-swal'
        },

        html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      if (!props.modal) {
        api.get('clientes/exportData', { params: queryObject }).then(r => {
          setExportData(r.data)
          console.log(r.data)
        })
      }
      api.get('/clientes', { params: queryObject }).then(r => {
        setData(r.data)
        swal.close()
      })
    } else {
      swal.fire({
        customClass: {
          container: 'my-swal'
        },

        title: 'Nenhum filtro informado!',
        html: '<p>Informe ao menos um filtro para realizar a busca.',
        icon: 'warning'
      })
    }
  }

  function clearForm(e) {
    e.preventDefault();
    if (!props.modal) {
      window.history.replaceState({ filtered: false }, 'filter', '/salute/clientes');
      document.getElementById('searchForm').reset()
    }
    setFilter({})
  }


  useEffect(() => {
    const fetchRep = async () => {
      const auxValues = { ...filter };
      auxValues["fk_rep"] = representante;
      auxValues["nomerep"] = ''
      if (representante > 0) {
        await api.get("/representantes?pk_rep=" + representante).then((r) => {
          if (r.data[0]) {
            auxValues["nomerep"] = r.data[0].nome;

          }
        });
      }
      setFilter(auxValues);
    };
    fetchRep();
  }, [representante]);


  const handleChange = (e) => {
    const auxValues = { ...filter };
    switch (e.target.name) {
      case 'cpf': auxValues.cpf = String(mCPF(e.target.value))
        break

      case 'fk_rep':
        setRepresentante(e.target.value);
        break

      default: auxValues[e.target.name] = e.target.value;
    }

    setFilter(auxValues);
  };


  function fechaModal(e) {
    props.setNomeCli(nomeCli)
    setModalRegistro(false)
    props.setShowModalCliente(false)
  }

  useEffect(() => {
    const fetchData = async () => {
      if (props.setNomeCli)
        props.setNomeCli(nomeCli)
      if (props.setPk_Cli)
        props.setPk_Cli(pk_cli)
    }

    fetchData()
  }, [nomeCli, pk_cli])


  function chamaRegistro(e) {
    e.preventDefault();
    console.log(props)
    if (!props.modal)
      window.location.href = "/salute/clientes/registro"
    else
      setModalRegistro(true)
  }

  function sair(e) {
    e.preventDefault();
    props.setShowModalCliente(false)
  }


  return (
    <div className={props.modal ? "ManutModal" : "Manut"}>
      {!props.modal ? <NavBar /> : <></>}
      <div className={props.modal ? "ManutContentModal" : "ManutContent"}>
        <div className="defaultHeader">
          <h3>{dependentes ? 'Clientes/Dependentes' : 'Clientes'}</h3>
          {!props.modal ? <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} /> : <></>}
        </div>
        <br />
        <div className="filtersDiv" style={{paddingInline:  props.modal ? 16 : 0}}>
          <form id="searchForm" onSubmit={getData}>
            <div>

              <FrTextInput
                maxLength='10'
                value={filter.pk_cli || ''}
                onChange={handleChange}
                name="pk_cli"
                id="pk_cli"
                color="#389492"
                label="Código"
                variant="outlined"
                size="small"
                style={{ width: 100 }}
              />


              <FrTextInput
                maxLength='100'
                value={filter.nome || ''}
                onChange={handleChange}
                name="nome"
                id="nome"
                color="#389492"
                label="Nome"
                variant="outlined"
                size="small"
                style={{ width: 300 }}
              />

              <FrTextInput
                maxLength='14'
                value={filter.cpf ? mCPF(filter.cpf) : ''}
                onChange={handleChange}
                name="cpf"
                id="cpf"
                color="#389492"
                label="CPF"
                variant="outlined"
                size="small"
                style={{ width: 160 }}
              />

              <FrSelect
                value={filter.fk_cid || -1}
                onChange={handleChange}
                name="fk_cid"
                id="fk_cid"
                label='Cidade'
                data={comboCid}
                style={{ width: 250 }}
                mostraTodos
              />

              <br />

              <FrTextInput
                maxLength='100'
                value={filter.nome_responsavel || ''}
                onChange={handleChange}
                name="nome_responsavel"
                id="nome_responsavel"
                color="#389492"
                label="Nome Responsável"
                variant="outlined"
                size="small"
                style={{ width: 300 }}
              />

              <FrTextInput
                maxLength='14'
                value={filter.cpf_responsavel ? mCPF(filter.cpf_responsavel) : ''}
                onChange={handleChange}
                name="cpf_responsavel"
                id="cpf_responsavel"
                color="#389492"
                label="CPF Responsável"
                variant="outlined"
                size="small"
                style={{ width: 160 }}
              />

              <br />
              <FrSelect
                value={filter.fk_ori || ''}
                onChange={handleChange}
                name="fk_ori"
                id="fk_ori"
                label='Origem Contato'
                data={comboOri}
                style={{ width: 300 }}
                mostraTodos
              />

              <FrSelect
                value={filter.fk_sub || ''}
                onChange={handleChange}
                name="fk_sub"
                id="fk_sub"
                label='SubOrigem Contato'
                data={comboSub}
                style={{ width: 300 }}
                mostraTodos
              />

              <AutoComp
                value={filter.nomerep || ""}
                valor={representante}
                width={400}
                tabela={'representantes'}
                chave={'nome'}
                name="fk_rep"
                id="fk_rep"
                label='Representante'
                data={comboRep}
                setValue={setRepresentante}
                form={'searchForm'}
                manut={'clientes'}
              />


              <FrSelect
                value={filter.ativo || ''}
                onChange={handleChange}
                name="ativo"
                id="ativo"
                label='Situação'
                data={comboAtivo}
                style={{ width: 150 }}
                mostraTodos
              />

            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>

              {enableAdd == 'S' ?
                <button onClick={chamaRegistro}>
                  <Icon icon={ic_add_box} size={18} />
                  Novo Registro
                </button>
                : <></>
              }

              {props.modal ?
                <button onClick={sair}>
                  <Icon icon={exit} size={18} />
                  Sair
                </button>
                : <></>
              }
              
              {
                !props.modal &&
              <ExcelFile 
                  element={
                    <button 
                      type='button'  
                      
                    >
                      <Icon icon={fileExcel} size={18} />
                      Exportar XLS
                    </button>
                  } 
                  filename="Clientes">
                    
                    

                <ExcelSheet data={exportData} name="Clientes">
                  <ExcelColumn label="CPF" value="cpf" />
                  <ExcelColumn label="Nome" value="nome" />
                  <ExcelColumn label="Nascimento" value="nascimento" />
                  <ExcelColumn label="Gênero" value="genero" />
                  <ExcelColumn label="Logradouro" value="logradouro" />
                  <ExcelColumn label="Número" value="numero" />
                  <ExcelColumn label="Complemento" value="complemento" />
                  <ExcelColumn label="Bairro" value="bairro" />
                  <ExcelColumn label="CEP" value="cep" />
                  <ExcelColumn label="Cidade" value="cidade" />
                  <ExcelColumn label="Estado" value="estado" />
                  <ExcelColumn label="Fone 1" value="fone_1" />
                  <ExcelColumn label="Fone 2" value="fone_2" />
                  <ExcelColumn label="E-mail" value="e_mail" />
                  <ExcelColumn label="Responsável" value="responsavel" />
                  <ExcelColumn label="Representante" value="representante" />
                  <ExcelColumn label="Origem" value="origem" />
                  <ExcelColumn label="Suborigem" value="sub_origem" />
                  <ExcelColumn label="Categoria" value="categoria" />
                  <ExcelColumn label="Ultimo Contrato" value="ultimo_contrato" />
                  <ExcelColumn label="Termino Contrato" value="termino_contrato" />
                  <ExcelColumn label="Cancelamento" value="cancelamento" />

                </ExcelSheet>
              </ExcelFile>
              }

            </div>
          </form>
        </div>
        <br />
        <div className="tableDiv" >
          <FrTable setShowModal={fechaModal} setPk_Cli={setPk_Cli} setNomeCli={setNomeCli} readOnly={props.modal} modal={props.modal} width={140}
            ctr={'/salute/contas_receber?'} pdf={'/salute/contratos?vigente=S&fk_cli='} historicos={true} regName="clientes" 
            columns={columns} searched={filtered} codeName="pk_cli" page={'Clientes'} data={data} enableEdit={enableEdit}
            enableDel={enableDel} />
        </div>

        <div>
          <Dialog aria-labelledby="simple-dialog-title" open={modalRegistro} fullWidth={true} maxWidth={'lg'}>
            <RegClientes 
              modal 
              setPk_Cli={props.modal ? props.setPk_Cli : setPk_Cli} 
              pk_cli={props.modal ? props.pk_cli : pk_cli} 
              setShowModal={fechaModal} 
              setNome={setNomeCli} 
              responsavel={props.responsavel}
              setCriouResponsavel={props.setCriouResponsavel}
            />
          </Dialog>
        </div>


        {!props.modal ? <FooterDelphus /> : <></>}

      </div>
    </div>
  );
}

export default Clientes;
